export default __webpack_public_path__ + "static/media/photo--sm--hockey6.1c419d4e.jpg";